import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

import { CompanyContextService } from '../company-context.service';

export interface ChatParticipant {
  id: number;
  nome: string;
  avatar: string | null;
  isAgent: boolean;
}

export interface ChatEmpresaItem {
  chatHash: string;
  title: string;
  image: string | null;
  lastMessage: string;
  lastMessageType: string;
  isGroup: boolean;
  messageCount: number;
  updatedAt: string;
  createdAt: string;
  users: ChatParticipant[];
}

export interface ChatEmpresaResponse {
  data: ChatEmpresaItem[];
  total: number;
  totalPages: number;
  currentPage: number;
}

export interface ChatIndicadores {
  totalChats: number;
  totalChatsLastMonth: number;
  totalMessages: number;
  totalMessagesDeleted: number;
  totalMessagesDeletedLastMonth: number;
  totalMessagesPercentageLastMonth: number;
}

@Injectable({ providedIn: 'root' })
export class ChatApiService {
  private readonly http = inject(HttpClient);
  private readonly _companyContext = inject(CompanyContextService);
  private readonly baseUrl = `${environment.apiUrl}/chat`;

  private get empresaId(): number {
    return this._companyContext.companyId() ?? 0;
  }

  // GET /chat/empresa/{idEmpresa}
  listAllChats(params: { search?: string; page: number; pageSize: number }): Observable<ChatEmpresaResponse> {
    let httpParams = new HttpParams()
      .set('page', params.page)
      .set('pageSize', params.pageSize);
    if (params.search) httpParams = httpParams.set('search', params.search);

    return this.http.get<ChatEmpresaResponse>(`${this.baseUrl}/empresa/${this.empresaId}`, { params: httpParams });
  }

  // GET /chat/arquivar-chat/{chatHash}
  arquivarChat(chatHash: string): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/arquivar-chat/${chatHash}`);
  }

  // GET /chat/empresa/{idEmpresa}/indicadores
  getIndicadores(): Observable<ChatIndicadores> {
    return this.http.get<ChatIndicadores>(`${this.baseUrl}/empresa/${this.empresaId}/indicadores`);
  }

  // POST /chat/check-exists-chat
  checkExistsChat(users: number[]): Observable<{ chatHash: string; isNew: boolean }> {
    return this.http.post<{ chatHash: string; isNew: boolean }>(`${this.baseUrl}/check-exists-chat`, { users });
  }
}
